import React, { useState } from 'react';
import AdminDashboardSwitcher, { getDefaultDashboardView } from './AdminDashboardSwitcher';
import DashboardLayout from './DashboardLayout';
import OwnerDashboardContent from './owner/OwnerDashboardContent';
import StudentDashboardContent from './student/StudentDashboardContent';
import TeacherDashboardContent from './teacher/TeacherDashboardContent';

/**
 * Owner Dashboard - Business Goals View
 *
 * This is the primary dashboard for platform owners, displaying business goals,
 * action plans, and strategic recommendations.
 *
 * Includes an admin switcher to toggle between Owner, Teacher, and Student Dashboards
 * for demo/testing purposes. User's preferred default view is stored in localStorage.
 */
const OwnerDashboard = ({
  dashboardData,
  searchQuery,
  isLoading
}) => {
  const [currentView, setCurrentView] = useState(getDefaultDashboardView); // 'owner', 'teacher', or 'student'

  const myCourses = dashboardData || [];
  const ownedCourses = myCourses.filter(course => course.canEdit);

  const renderDashboardContent = () => {
    switch (currentView) {
      case 'student':
        return <StudentDashboardContent dashboardData={myCourses} isLoading={isLoading} />;
      case 'teacher':
        return <TeacherDashboardContent dashboardData={myCourses} isLoading={isLoading} />;
      default:
        return <OwnerDashboardContent />;
    }
  };

  return (
    <>
      <AdminDashboardSwitcher
        currentView={currentView}
        onViewChange={setCurrentView}
      />
      <DashboardLayout
        searchQuery={searchQuery}
        dashboardData={ownedCourses}
        showSearchResults={searchQuery.length > 0}
      >
        {renderDashboardContent()}
      </DashboardLayout>
    </>
  );
};

export default OwnerDashboard;
